const directors = [
  { name: "Mr. Dines Venkitachalam", role: "Director" },
  { name: "Mrs. Jayasri", role: "Director" }
];
const managingDirectors = [
  { name: "Mr. E Venu Gopal", role: "Managing Director" }
];

export default function BoardOfDirectors() {
  return (
    <section
      className="position-relative w-100 py-5 text-center text-white"
      style={{
        backgroundImage: "url('/bg.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      id="boardofdirectors"
    >
      {/* Overlay */}
      <div className="position-absolute top-0 start-0 w-100 h-100 bg-primary opacity-50"></div>

      <div className="position-relative container py-4">
        <h2 className="fw-bold display-5 mb-4">BOARD OF DIRECTORS</h2>
        <div className="row justify-content-center">
          {managingDirectors.map((managingDirector, index) => (
            <div key={index} className="col-md-6 mb-3">
              <h3 className="h5 fw-semibold">{managingDirector.name}</h3>
              <p className="text-light">{managingDirector.role}</p>
            </div>
          ))}        
        </div>
        <div className="row justify-content-center">
          {directors.map((director, index) => (
            <div key={index} className="col-md-6 mb-3">
              <h3 className="h5 fw-semibold">{director.name}</h3>
              <p className="text-light">{director.role}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
